/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumMaterialableTypeFromJSON, EnumMaterialableTypeToJSON } from './EnumMaterialableType';
export function PinMaterialListRequestFromJSON(json) {
    return PinMaterialListRequestFromJSONTyped(json, false);
}
export function PinMaterialListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        materialableType: !exists(json, 'materialable_type')
            ? undefined
            : EnumMaterialableTypeFromJSON(json['materialable_type']),
        materialableIds: !exists(json, 'materialable_ids') ? undefined : json['materialable_ids']
    };
}
export function PinMaterialListRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        materialable_type: EnumMaterialableTypeToJSON(value.materialableType),
        materialable_ids: value.materialableIds
    };
}
